import { costCents, FLASH } from './aiModels';

/**
 * The AI's cost cap (1.28.1). 26.10. one day of runaway answers cost 13 € – Mike, 27.10.: "eine
 * dynamische grenze … abhängig von der Anzahl der (später zahlenden) Nutzer … multipliziert mit
 * einen budget pro familie". Amounts in cents; Google bills US$, we count those cents as euro
 * cents (a little on the safe side).
 */
export interface AiBudget {
  /** For everyone together per day: the beta, test families, the admin's tests. */
  baseCents: number;
  /** Per family with the AI switched on, per day – also each family's own cap. */
  familyCents: number;
}

/** Mike's starting values (27.10.): 0,20 € a day plus 0,02 € per family and day. */
export const AI_BUDGET_DEFAULTS: AiBudget = { baseCents: 20, familyCents: 2 };

/** Today's cap for everybody: grows with the families that use the AI. */
export const dailyLimitCents = (b: AiBudget, families: number) =>
  b.baseCents + Math.max(0, families) * b.familyCents;

/**
 * What one call cost. Tokens of a retry on the other model are summed up in the report, so a
 * retried call is priced as Flash – the dearer guess.
 */
export const callCents = (r: {
  model: string;
  attempts: number;
  tokensIn: number;
  tokensOut: number;
}) => costCents(r.attempts > 1 ? FLASH : r.model, r.tokensIn, r.tokensOut);

export type AiBudgetBlock = 'app' | 'family';

/** May one more call go out? The app's cap first – it protects the bill. */
export function aiBudgetBlock(
  b: AiBudget,
  day: { cents: number; families: number },
  familySpent: number,
): AiBudgetBlock | null {
  if (day.cents >= dailyLimitCents(b, day.families)) return 'app';
  if (familySpent >= b.familyCents) return 'family';
  return null;
}

/** Mike gets one mail at each step – 80 % as a warning, 100 % when the AI pauses. */
export function budgetStep(cents: number, limit: number): 0 | 80 | 100 {
  if (limit <= 0 || cents >= limit) return 100;
  return cents >= limit * 0.8 ? 80 : 0;
}
